export const en = {
  nav: { home: "Home", services: "Services", fleet: "Fleet", pricing: "Pricing", blog: "Blog", contact: "Contact", book: "Book Now", call: "Call", cities: "Destinations" },
  hero: {
    overline: "LUXURY VTC RIVIERA",
    title: "Your Private Driver on the",
    titleAccent: "French Riviera",
    subtitle: "Premium chauffeur service in Nice, Monaco, Cannes and the entire Côte d'Azur. Airport transfers, events and tailor-made trips 24/7.",
    cta1: "Book now",
    cta2: "Get a quote",
    badge1: "24/7 Available",
    badge2: "Certified driver",
    badge3: "Transparent rates",
    clarityOverline: "Private VTC chauffeur · Nice & French Riviera",
    clarityText: "Airport transfers, Monaco, Cannes, Antibes, Saint-Tropez. Price based on the real route.",
    point1: "Real-route pricing",
    point2: "Quote in 2 min",
    point3: "No account required",
  },
  home: {
    heroOverline: "Eco-Friendly VTC · Nice & French Riviera",
    heroTitle: "VlaDriver VTC — Eco-Friendly Private Chauffeur on the French Riviera",
    heroSubtitle: "Enjoy premium comfort in our 100% Hybrid fleet (Toyota C-HR & Corolla Cross). Guaranteed fixed rates, known in advance.",
    heroBadge: "5.0/5 · Top Rated Chauffeur on Google",
    heroCtaPrice: "View rates",
    heroCtaBook: "Request my fixed rate",
    pricingOverline: "All-inclusive packages",
    pricingTitle: "Guaranteed fixed rates",
    pricingSubtitle: "The price is known in advance. No surprises, no meter.",
    pricingAllInc: "All inclusive",
    pricingOnRequest: "Rate on request",
    pricingNote: "Tolls, meet & greet and luggage included. Night surcharge (11pm–6am) and Sundays/holidays: +15%.",
    leadOverline: "Rate request",
    leadTitle: "Request your fixed rate",
    leadSubtitle: "Just 4 fields — quick reply by phone or WhatsApp.",
    leadName: "Full name",
    leadPhone: "Phone / WhatsApp",
    leadPickup: "Pickup point",
    leadDestination: "Destination",
    leadSubmit: "Book via WhatsApp",
    leadSending: "Sending...",
    leadSuccessTitle: "Request sent ✓",
    leadSuccessBody: "Thank you! We'll get back to you very soon. You can finalize right now on WhatsApp.",
    leadWhatsapp: "Continue on WhatsApp",
    leadError: "Something went wrong. Please retry or call us at +33 7 83 97 73 70.",
    reviewsOverline: "Customer reviews",
    reviewsTitle: "5.0/5 on Google",
    reviewsSubtitle: "Rated 5 stars by our clients across the French Riviera.",
    reviewsCta: "See our Google reviews",
    waReserve: "Book via WhatsApp",
    quickRoutes: "Popular routes:",
    widgetTitle: "Book your chauffeur",
    widgetSubtitle: "Enter your trip, see the fare, pay online in 1 min.",
    googleContinue: "Continue with Google",
    bookDate: "Date",
    bookTime: "Time",
    bookEmail: "Email",
    priceComputing: "Calculating fare…",
    priceLabel: "Your fare",
    priceAllInc: "all inclusive",
    priceError: "Couldn't calculate this trip. Please refine the addresses.",
    enterTripForPrice: "Enter pickup and destination to see your fare.",
    payNow: "Book & Pay",
    payRedirect: "Redirecting to payment…",
    paySecure: "Secure payment · Ride confirmed instantly",
    paymentSoon: "Your booking is saved. Online payment will be active very soon — we'll contact you to finalize.",
    payError: "Something went wrong. Please retry.",
    payChecking: "Verifying payment…",
    paySuccessTitle: "Booking confirmed ✓",
    paySuccessBody: "Your ride is booked and paid. See you soon!",
    payPendingTitle: "Payment in progress…",
    payPendingBody: "We're finalizing your payment. This page updates automatically.",
    payFailedTitle: "Payment not completed",
    payFailedBody: "The payment could not be completed. You can try again.",
    payRetry: "Try again",
    orderTime: "Order placed on",
    parisTime: "(France time)",
    paidTime: "Paid on",
    backHome: "Back to home",
  },
  booking: {
    title: "Quick Booking",
    subtitle: "Get your quote in less than 2 minutes",
    quoteBadge: "— Quote request",
    heading: "Book your transfer",
    subheading: "Personalized quote sent within 15 minutes",
    pickup: "Pickup location",
    pickupPh: "Airport, hotel, address...",
    destination: "Destination",
    destinationPh: "Monaco, Cannes, hotel...",
    date: "Date", time: "Time", passengers: "Passengers", luggage: "Luggage",
    name: "Full name", phone: "Phone", email: "Email (optional)",
    flight: "Flight number (optional)", message: "Message or special request",
    vehicle: "Vehicle",
    chrDesc: "Hybrid · 4 pax",
    corollaDesc: "Sedan · 4 pax",
    submit: "Confirm booking",
    requestQuote: "Request a quote",
    confirmBooking: "Confirm booking",
    confirmedTitle: "Booking confirmed",
    firmPriceLabel: "Firm price",
    tollsIncluded: "Total price, tolls included",
    confirmedBody: "All set! Vlad will contact you shortly for the final details.",
    confirmedBodyNoPrice: "Your request is registered. Vlad will get back to you within 15 min with the price and details.",
    signInToQuote: "Sign in to request a quote",
    success: "Booking sent! We'll contact you within 15 minutes.",
    error: "Error. Please try again or call us directly.",
    successTitle: "Request received",
    successBody: "We'll send you a personalized quote within {{min}}.",
    successNote: "You'll receive the price in your personal space — electronic signature required to confirm.",
    successNoteGuest: "Vlad will confirm the price and time by phone or email. No account needed.",
    viewMyRequest: "View my request",
    newRequest: "New request",
    quoteInfoTitle: "Personalized quote",
    quoteInfoBody: "{{fixedPrice}} price shown for the real route, booking confirmed instantly.",
    quoteInfoBodyFixed: "Firm",
    quoteInfoNote: "Total price, tolls included. No account required.",
    estimateBtn: "Estimate the price",
    estimateLoading: "Calculating…",
    estimateMissing: "Please fill in pickup and destination.",
    estimateUnavailable: "Estimate unavailable.",
    estimateNetworkError: "Network error. Please retry.",
    estimateHeading: "Trip price",
    estimateTrip: "Trip",
    estimateDisclaimer: "Firm price based on the real route, tolls included.",
    estimateTollsNote: "Total price, tolls included, stated in the quote before acceptance",
    estimateAirportNote: "Airport pickup fee included",
    estimateNightNote: "Night rate (23:00 – 06:00) applied",
    estimateIncludedNote: "Welcome sign and luggage included",
    reminderOptinTitle: "No time right now?",
    reminderOptinSubtitle: "We'll send you a reminder of this estimate in 15 min, right on this phone.",
    reminderOptinCta: "Enable",
    reminderActive: "Reminder enabled — we'll notify you in 15 min.",
  },
  services: {
    title: "Our VTC Services",
    subtitle: "A premium fleet for every journey",
    airport: { title: "Nice Airport Transfer", desc: "Personalized welcome in arrivals area with name sign. Real-time flight tracking." },
    monaco: { title: "Nice ↔ Monaco", desc: "Direct trip to the Principality in under 30 minutes. Ideal for Grand Prix and VIP events." },
    cannes: { title: "Nice ↔ Cannes", desc: "Privileged service for Festival, Mipim and galas. Discretion and punctuality guaranteed." },
    business: { title: "Business Transport", desc: "Hourly or daily availability. Roadshows, seminars, professional trips." },
    luxury: { title: "Luxury Hotels", desc: "Partner with Riviera palaces: Negresco, Carlton, Hermitage, Hôtel de Paris." },
    events: { title: "Weddings & Events", desc: "Elegant transport for your guests. Custom packages for ceremonies and private parties." },
    cruise: { title: "Cruises", desc: "Transfers to and from ports of Nice, Cannes, Villefranche, Monaco." },
    hourly: { title: "Hourly Service", desc: "Driver at your disposal for shopping, visits, successive appointments." },
  },
  pricing: { title: "Transparent Pricing", subtitle: "Fixed prices for popular routes", duration: "Duration", price: "Price", quote: "Custom quote", note: "Indicative prices incl. tax for sedan up to 4 passengers." },
  fleet: {
    title: "Our Fleet",
    subtitle: "Two premium vehicles to choose from: Toyota C-HR & Toyota Corolla 2026",
    feat1: "Dual-zone climate", feat2: "Leather seats", feat3: "Premium onboard comfort",
    feat4: "USB chargers", feat5: "Bluetooth audio", feat6: "Eco-friendly hybrid",
  },
  trust: {
    title: "Why VlaDriver?",
    stat1: { num: "5+", label: "Years experience" },
    stat2: { num: "10K+", label: "Happy clients" },
    stat3: { num: "4.9/5", label: "Average rating" },
    stat4: { num: "24/7", label: "Availability" },
    feat1: "Certified VTC driver (professional card)",
    feat2: "Premium all-risk insurance",
    feat3: "Fixed prices, no surprises",
    feat4: "Card, cash or transfer payment",
    feat5: "Multilingual: French, English, Italian, Romanian",
    feat6: "Free cancellation up to 12h before",
  },
  testimonials: { title: "They trust us", subtitle: "Verified client reviews" },
  faq: { title: "Frequently Asked Questions", subtitle: "Everything you need to know before booking" },
  cta: { title: "Ready for your next trip?", subtitle: "Book in 2 minutes or call us directly", book: "Book online", whatsapp: "WhatsApp" },
  footer: {
    tagline: "Premium Private Chauffeur — Nice & French Riviera",
    serviceTitle: "Our Services", cityTitle: "Destinations", blogTitle: "Blog & Tips", contactTitle: "Contact",
    legal: "Legal", privacy: "Privacy Policy", cgv: "Terms", rights: "All rights reserved.",
    siret: "SIRET in progress", license: "Official VTC license",
  },
  common: { readMore: "Read more", backHome: "Back home", minutes: "min", from: "From", quote: "On request" },
};
